import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "align-items-center pt-3 border-top border-1 border-black border-opacity-25 mb-2" }
const _hoisted_2 = { class: "align-items-center pt-3 border-top border-1 border-black border-opacity-25 mb-2" }
const _hoisted_3 = { class: "col-9 col-xl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_CategoryImageEditor = _resolveComponent("CategoryImageEditor")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_base_offcanvas_button_close = _resolveComponent("base-offcanvas-button-close")!
  const _component_GenericFormWrapper = _resolveComponent("GenericFormWrapper")!

  return (_openBlock(), _createBlock(_component_GenericFormWrapper, {
    pageUI: _ctx.pageUI,
    submitData: _ctx.submitData
  }, {
    content: _withCtx(({ errors }) => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allLanguages, (lang) => {
          return (_openBlock(), _createElementBlock("div", {
            key: lang,
            class: "col-12"
          }, [
            _createVNode(_component_InputText, {
              modelValue: _ctx.category.name[lang],
              "onUpdate:modelValue": [($event: any) => ((_ctx.category.name[lang]) = $event), _ctx.onFormDataChanged],
              modelModifiers: { trim: true },
              label: `${_ctx.$t('name')} ${lang}`,
              name: `name${lang}`,
              rules: `atLeastOneMultilingualField:name,${_ctx.allLanguages.join('-')},${_ctx.$t('name')}|max:255`,
              errors: errors
            }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "name", "rules", "errors"])
          ]))
        }), 128))
      ]),
      _createVNode(_component_CategoryImageEditor, {
        modelValue: _ctx.imageRestDto,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.imageRestDto) = $event)),
          _ctx.onImageChanged
        ],
        docType: _ctx.docType,
        title: _ctx.$t('image')
      }, null, 8, ["modelValue", "docType", "title", "onUpdate:modelValue"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_InputSelect, {
            name: "cbStatus",
            class: "fw-bold",
            selectText: _ctx.$t('selectText'),
            modelValue: _ctx.publishedStatus,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => ((_ctx.publishedStatus) = $event)),
              _ctx.onFormDataChanged
            ],
            options: [
              { code: _ctx.StatusEnum.PUBLISHED, description: _ctx.$t('published') },
              { code: _ctx.StatusEnum.NOT_PUBLISHED, description: _ctx.$t('notPublished') }
            ],
            errors: errors
          }, null, 8, ["selectText", "modelValue", "options", "errors", "onUpdate:modelValue"])
        ])
      ])
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_base_offcanvas_button_close, {
        ref: "closeButton",
        class: "btn btn-light",
        disabled: _ctx.pageUI.isSubmitting()
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('close')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _: 1
  }, 8, ["pageUI", "submitData"]))
}